import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import type { Id } from "src/types/id";
import type { Pos } from "src/types/pos";
import type { PosGroup } from "src/types/posGroup";
import { UserRoleEnum } from "src/types/role";

import { useTranslation } from "src/design-system/core/TranslationContext";
import { USER_CREATE_FORM_TK } from "src/views/admin/AdminView/user/config";
import { ADMIN_TRANSLATION_NAMESPACE } from "src/views/admin/config";

export const useFormSchema = () => {
    const { t, translateCommon } = useTranslation(
        `${ADMIN_TRANSLATION_NAMESPACE}:${USER_CREATE_FORM_TK}`
    );

    return yupResolver(
        yup.object().shape({
            role: yup.string().required(translateCommon("forms.required", { field: t("role") })),
            organization: yup.string().when("role", {
                is: (role) => role !== UserRoleEnum.SUPERADMIN,
                // biome-ignore lint/suspicious/noThenProperty: expected in this case
                then: yup
                    .string()
                    .required(translateCommon("forms.required", { field: t("organization") })),
            }),
            poss: yup.array().when("role", {
                is: (role) => role !== UserRoleEnum.SUPERADMIN,
                // biome-ignore lint/suspicious/noThenProperty: expected in this case
                then: yup.array().required(translateCommon("forms.required", { field: t("pos") })),
            }),
            firstName: yup
                .string()
                .required(translateCommon("forms.required", { field: t("first-name") })),
            lastName: yup
                .string()
                .required(translateCommon("forms.required", { field: t("last-name") })),
            email: yup
                .string()
                .email(translateCommon("forms.valid.email"))
                .required(translateCommon("forms.required", { field: t("email-name") }))
                .test("superadmin", t("email-super-admin"), function (value) {
                    return (
                        this.parent.role !== UserRoleEnum.SUPERADMIN || value.endsWith("goflynt.io")
                    );
                }),
        })
    );
};

export const availablePointsOfSales = (selectedOrganization: Id, pointsOfSales: Pos[]): Pos[] => {
    return pointsOfSales.filter((e) => e.organizationId === selectedOrganization);
};

export const availablePointOfSalesGroups = (
    selectedOrganization: Id,
    pointOfSalesGroups: PosGroup[]
): PosGroup[] => {
    return pointOfSalesGroups.filter((e) => e.organizationId === selectedOrganization);
};
